import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import memoizeOne from 'memoize-one';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core';
import { RemoveRedEye as ViewIcon } from '@material-ui/icons';
import { withRouter } from 'react-router-dom';
import { FHETable } from 'data/components';
import tools from "../../../../../data/common/tools";

class TableProjects extends PureComponent {
    static propTypes = {
        history: PropTypes.object.isRequired,
        classes: PropTypes.object.isRequired,
        profile: PropTypes.object.isRequired,
        projects: PropTypes.object.isRequired
    };

    navigateToDetail = rowData => {
        const { history } = this.props;
        return history.push({ pathname: `/${history.environment}/project/detail/${rowData.id}` });
    };

    renderData = memoizeOne(projects => {
        let results = [];

        projects.map((project, projectId) => {
            results.push({
                id: parseInt(projectId),
                label: project.get('label'),
                email: project.get('email'),
                residents: project.get('residents'),
                surface: parseInt(project.get('surface')),
                surfaceNumber: parseInt(project.get('surface')),
                price: parseInt(project.get('price')),
                priceFHE: parseInt(project.get('priceFHE')),
                lastUpdate: project.get('lastUpdate')
            });
        });

        return results;
    });

    renderActions = memoizeOne(profile => {
        const { history } = this.props;
        const userRights = profile.getIn(['user_rights', history.environment], []);

        let actions = {
            row: [],
            toolbar: []
        };
        if (profile.get('admin') || userRights.includes('projectDetails')) {
            actions.row.push({
                icon: ViewIcon,
                onClick: this.navigateToDetail,
                tooltip: Translator.translate(`$general.showDetail`)
            });
        }
        return actions;
    });
    renderColumns = memoizeOne(profile => {
        const { history } = this.props;
        return [
            {
                title: Translator.translate('general.table.column.label'),
                name: 'label',
                action: (profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('projectDetails')) && {
                    onClick: this.navigateToDetail,
                    tooltip: Translator.translate(`$general.showDetail`)
                }
            },
            {
                title: Translator.translate('general.table.column.email'),
                name: 'email'
            },
            {
                title: Translator.translate('general.table.column.residents'),
                name: 'residents'
            },
            {
                title: Translator.translate('general.table.column.surface'),
                name: 'surface',
                render: (row, data, value) => {
                    if (!value) return null;
                    return `${value}m²`;
                }
            },
            {
                title: Translator.translate('general.table.column.price'),
                name: 'price',
                render: (row, data, value) => {
                    if (!value) return null;
                    return `${value} €`;
                }
            },
            {
                title: Translator.translate('general.table.column.priceFHE'),
                name: 'priceFHE',
                render: (row, data, value) => {
                    if (!value) return null;
                    return `${value} €`;
                }
            },
            {
                title: Translator.translate('general.table.column.lastUpdate'),
                name: 'lastUpdate',
                customSort: tools.sortDate
            }
        ];
    });

    renderProduct() {
        const { projects, profile } = this.props;

        return (
            <FHETable
                idTable="commercialAgentDetailProjects"
                columns={this.renderColumns(profile)}
                data={this.renderData(projects)}
                actions={this.renderActions(profile)}
                minified
            />
        );
    }

    render() {
        const { projects, classes, history } = this.props;
        return (
            <Fragment>
                {projects.size > 0 ? (
                    this.renderProduct()
                ) : (
                    <div className={classes.divStyle}>{Translator.translate(`${history.environment}.project.table.body.emptyDataSourceMessage`)}</div>
                )}
            </Fragment>
        );
    }
}

function mapStateToProps(state, props) {
    const { commercialAgentId, history } = props;
    const projects = state.environments[history.environment].data.Projects.get('list').filter(Project => {
        return Project.get('commercialAgentId') === commercialAgentId;
    });

    return {
        profile: state.data.user,
        projects
    };
}

const styles = theme => ({
    divStyle: {
        color: theme.palette.text.primary
    }
});

export default withRouter(connect(mapStateToProps)(withStyles(styles, { withTheme: true })(TableProjects)));



// WEBPACK FOOTER //
// ./environments/simulationenr/scenes/CommercialAgent/Table/TableProjects.js